import { useIntl } from 'react-intl';

import { getLocalUserId } from 'src/features/auth';
import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import ProfileSettingsForm from 'src/features/profile/components/ProfileSettingsForm';
import { settingsMessages } from 'src/features/profile/utils';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSubtitle,
    SectionBlockSeparator,
    SectionBlockBody,
} from 'src/registry/components/blocks/SectionBlock';

const Settings = () => {
    const { formatMessage } = useIntl();
    const userId = getLocalUserId();

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(settingsMessages.settingsTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>{formatMessage(settingsMessages.settingsSubtitle)}</SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody>
                    <ProfileSettingsForm userId={userId} />
                </SectionBlockBody>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Settings;
